export const SITE = {
  name: "Anchor Services",
  domain: "anchorsrq.com",
  phone: "(941) 500-2320", // TODO: replace with real phone
  phoneHref: "tel:+19415002320",
  email: "info@anchorsrq.com",
  city: "Sarasota",
  region: "FL",
  hours: "Mon–Sat 8am–6pm",
  tagline: "Sarasota Complete Property Care",
};

export const SERVICE_AREAS = [
  "Sarasota",
  "Venice",
  "Nokomis",
  "Osprey",
  "Lakewood Ranch",
  "Palmer Ranch",
  "Siesta Key",
  "Longboat Key",
  "Bradenton",
] as const;

export const SECONDARY_SERVICES = [
  { slug: "junk-removal", title: "Junk Removal", short: "Fast, full-service junk hauling for homes and properties." },
  { slug: "estate-cleanouts", title: "Estate Cleanouts", short: "Compassionate, complete estate cleanouts for families and executors." },
  { slug: "property-cleanouts", title: "Property Cleanouts", short: "Full-property clearing for landlords, agents, and owners." },
  { slug: "garage-cleanouts", title: "Garage Cleanouts", short: "Reclaim your garage with a same-day clear-out." },
  { slug: "foreclosure-cleanouts", title: "Foreclosure Cleanouts", short: "Trusted cleanouts for banks, REO teams, and asset managers." },
  { slug: "eviction-cleanouts", title: "Eviction Cleanouts", short: "Discreet, court-ready eviction cleanouts for landlords." },
  { slug: "storm-debris-removal", title: "Storm Debris Removal", short: "Fast post-storm debris hauling across the Sarasota coast." },
  { slug: "furniture-removal", title: "Furniture Removal", short: "Heavy lifting and careful furniture removal, single piece to whole home." },
  { slug: "appliance-removal", title: "Appliance Removal", short: "Safe disconnect and removal of refrigerators, washers, ranges and more." },
  { slug: "concierge-services", title: "Concierge Services", short: "Personal property concierge for absentee and seasonal homeowners." },
] as const;

export type FaqItem = { q: string; a: string };

export const faqJsonLd = (faqs: FaqItem[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const SERVICE_AREA_PLACES = [
  "Sarasota, FL",
  "Siesta Key, FL",
  "Longboat Key, FL",
  "Lakewood Ranch, FL",
  "Bradenton, FL",
  "Venice, FL",
  "Osprey, FL",
  "Nokomis, FL",
] as const;

type ServiceSchemaInput = {
  slug: string;
  name: string;
  serviceType: string;
  description: string;
};

export const serviceJsonLd = ({ slug, name, serviceType, description }: ServiceSchemaInput) => {
  const url = `https://anchorsrq.com/${slug}`;
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${url}#service`,
    name,
    serviceType,
    description,
    url,
    provider: { "@id": "https://anchorsrq.com/#business" },
    areaServed: SERVICE_AREA_PLACES.map((a) => {
      const [city, region] = a.split(", ");
      return { "@type": "City", name: city, address: { "@type": "PostalAddress", addressLocality: city, addressRegion: region, addressCountry: "US" } };
    }),
  };
};

export const breadcrumbJsonLd = (items: Array<{ name: string; url: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: it.url,
  })),
});